module.exports = __webpack_public_path__ + "vn.3e303f7f.svg";